var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOk = function SvgOk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_176_3721)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5.25c-8.273 0-15 6.727-15 15s6.727 15 15 15 15-6.727 15-15-6.727-15-15-15z",
    fill: "#FF8500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.754 10.193a.94.94 0 0 1 0 1.325l-8.79 8.789a.936.936 0 0 1-1.323 0l-4.395-4.395a.94.94 0 0 1 0-1.324.94.94 0 0 1 1.324 0l3.733 3.732 8.127-8.127a.93.93 0 0 1 1.324 0z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_176_3721"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 .25)",
    d: "M0 0h30v30H0z"
  })))));
};
export default SvgOk;